import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/pages/layoutChrome";
import ModuleClientSelector from "@/components/ModuleClientSelector";
import ValidacionContribuyentesRfcCurp from "@/pages/laboral/ValidacionContribuyentesRfcCurp";
import {
  resolveDatosMaestrosAwareBreadcrumb,
  resolveDatosMaestrosReturnTarget,
} from "@/modules/datosMaestros/datosMaestrosNavigation";
import { useDatosMaestrosNavigationContext } from "@/modules/datosMaestros/useDatosMaestrosNavigationContext";
import { TRAMITES_CONTEXT_LABEL } from "@/modules/tramites/manifest";

const PAGE_TITLE = "Validación de RFC SAT";

/**
 * Pantalla canónica — validación RFC/CURP asistida (portal SAT).
 */
export default function DatosMaestrosValidacionRfcSatPage({
  testId = "datos-maestros-validacion-rfc-sat-page",
}) {
  const location = useLocation();
  useDatosMaestrosNavigationContext();
  const returnTo = resolveDatosMaestrosReturnTarget(location, "/datos-maestros");
  const returnLabel =
    location.state?.returnLabel
    || (returnTo.includes("panel=datos-maestros") ? "Volver al Panel General" : "Volver a Datos Maestros");

  return (
    <div className="space-y-0 min-h-full" data-testid={testId}>
      <PageHeader
        title={PAGE_TITLE}
        subtitle="Valide RFC y CURP de trabajadores o contribuyentes con el flujo asistido del portal SAT."
        breadcrumb={resolveDatosMaestrosAwareBreadcrumb(location, TRAMITES_CONTEXT_LABEL, PAGE_TITLE)}
      />

      <div className="px-8 py-6 w-full max-w-none space-y-6">
        <Link
          to={returnTo}
          className="inline-flex items-center gap-2 rounded-sm border border-[#0F2D5C]/25 bg-[#0F2D5C]/[0.04] px-3 py-1.5 text-xs font-semibold text-[#0F2D5C] shadow-sm hover:bg-[#0F2D5C]/10"
          data-testid="back-to-datos-maestros"
        >
          <ArrowLeft className="w-4 h-4 shrink-0" strokeWidth={2.25} />
          {returnLabel}
        </Link>

        <ModuleClientSelector variant="panel" className="mb-2" />

        <ValidacionContribuyentesRfcCurp embedMode="tramites" />
      </div>
    </div>
  );
}
